import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/**
 * Soft-deletes the token server-side; it stops authenticating on its very next request.
 *
 * `allow404` keeps a revoke of an already-gone token an error on the modal rather than a
 * page-wide redirect to the not-found route — see the interceptor in `apps/admin/src/axios.ts`.
 */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ accountId, id }: { accountId: number; id: number }) => {
      const { api, baseURL } = getApi()
      return api.delete(
        `/api/v2/accounts/${accountId}/public-api-tokens/${id}`,
        { baseURL, allow404: true },
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-public-api-tokens'] })
    },
  })
}
